// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_3wGGS","modalRoot":"_2GpjT","root":"wYuht","closeIcon":"_3yzI1","title":"_3xeK3","description":"_-lGO","channels":"_2_AIm","emptyChannels":"_37tTM","channel":"_1lKMK"};